import useInitialCheckoutValidation from '../hooks/useInitialCheckoutValidation'

/** Restores the stored cart where the navbar cart button isn't shown */
export default function InitialCheckoutValidation() {
  useInitialCheckoutValidation()

  return null
}
